import React, { useState, useEffect } from "react";
import {
  BackNextButton,
  AddButton,
  Modal,
  EditCard,
  Button,
} from "../../../../../common";
import { EditCardItems } from "../EditCardItems";
import { AddBankingForm } from "./AddBankingForm";
import { ReactComponent as Address } from "../../../../../../assets/images/companyIcons/CompanyProfile/address.svg";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
import { ReactComponent as Designation } from "../../../../../../assets/images/companyIcons/CompanyProfile/designation.svg";
import { ReactComponent as EmailIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/email.svg";
import { ReactComponent as NameIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/name.svg";
import { ReactComponent as TelephoneIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/telephone.svg";
import { useSelector } from "react-redux";
import { useBankdetailsdraftFetchMutation, useDeleteBankDraftMutation, useUpdateBankMutation } from '../../../../../../store/Company/companyApiSlice'
import { useGetCompanyQuery } from "../../../../../../store/Company/companyApiSlice";
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";

export const BankingInformation = ({ onPrev, onNext, onSkip, handleUpdateStatus, compRefetch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [banks, setBanksInfo] = useState([]);
  const [editBank, setEditBank] = useState(null);
  const [banksDraft, setBanksInfoDraft] = useState([]);
  const [BankdetailsdraftFetch] = useBankdetailsdraftFetchMutation();
  const [deletebankDraft] = useDeleteBankDraftMutation()
  const [updateBankMutation, { isLoading: isUpdating }] = useUpdateBankMutation();
  const { token } = useSelector((state) => state.auth);
  const { currentEditingCompany } = useSelector((state) => state.company);
  const [dataChanged, setDataChanged] = useState(false);


  const { data, isLoading, refetch } = useGetCompanyQuery({
    companyId: currentEditingCompany?.companyID,
    token,
  });
  useEffect(() => {
    if (!currentEditingCompany) return;
    let resultArr = [];
    let bankDettemp = currentEditingCompany?.bankDetails?.forEach(function (obj) {
      if (obj?.bankID?.is_deleted == 0) {
        resultArr.push(obj)
      }
    });
    setBanksInfo(resultArr);
    const companyStatus = async () => {
      let dataval = await BankdetailsdraftFetch({
        companyID: currentEditingCompany?.companyID,
        token,
      });
      if (dataval?.data?.data) {
        let respData = dataval?.data?.data;
        let tempArr = [];
        let draft_ids = [];
        let ids = [];
        let main_ids = [];
        for (let i = 0; i < respData.length; i++) {
          draft_ids.push(respData[i]?.bankID_id);
          tempArr.push(respData[i]);
        }
        currentEditingCompany?.bankDetails?.forEach(function (obj) {
          if (obj?.bankID?.is_deleted == 0) {
            ids.push(obj?.bankID?.bankID)
          }
        });
        ids?.forEach(function (id) {
          if (!draft_ids.includes(id))
            main_ids.push(id)
        })
        currentEditingCompany?.bankDetails?.forEach(function (obj) {
          if (obj?.bankID?.is_deleted == 0) {
            if (main_ids.includes(obj?.bankID?.bankID)) {
              tempArr.push(obj?.bankID)
            }
          }
        });
        setBanksInfoDraft(tempArr)
      }
    }
    companyStatus();
  }, [currentEditingCompany, dataChanged]);

  const modalHandle = (bankInfo) => {
    setIsOpen(!isOpen);
    setEditBank(bankInfo);
    refetch();
  };
  const modalHandleDelete = async (bankInfo) => {
    if (bankInfo?.bank_draftID) {
      let dataval = await deletebankDraft({
        data: bankInfo?.bank_draftID,
      });
      if (dataval?.data == null) {
        alert("Bank Information Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    } else if (bankInfo?.bankID) {
      const formData = new FormData();
      formData.append("is_deleted", 1);
      let res = await updateBankMutation({
        data: formData,
        bankId: bankInfo?.bankID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Bank Information Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    }
  }
  const liList = [
    { heading: "Bank Name", subHeading: "Abu Dhabi Ports Company" },
    { heading: "IBAN", subHeading: "897441614798551" },
    { heading: "Country", subHeading: "United Arab Emirates" },
  ];

  function createArrayFromObject(object) {
    let otherData = ["bank_name", "IBAN", "country"];
    let icons = {
      bank_name: <NameIcon />,
      IBAN: <Designation />,
      country: <EmailIcon />,
    };

    let data = [];

    for (let key in object) {
      if (otherData.includes(key)) {
        data.push({ [key]: object[key], icon: icons[key] });
      }
    }

    let keyValuePairs = data.map((item) =>
      Object.entries(item).map(([key, value]) => [key, value])
    );

    let html = keyValuePairs.map((item) => (
      <EditCardItems
        heading={item[0][0]?.replaceAll("_", " ")}
        subHeading={item[0][1]?.replace("|", "")}
        icon={item[1][1]}
      />
    ));
    return html;
  }

  return (
    <div className="mt-5 mr-20">
      {isOpen && (
        <Modal modalHandle={() => modalHandle(null)}>
          <AddBankingForm editBank={editBank} modalHandle={modalHandle} compRefetch={compRefetch} refetch={refetch} dataChanged={dataChanged} setDataChanged={setDataChanged} />
        </Modal>
      )}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
        Banking Information
      </h3>

      <div className="border border-slate rounded-lg p-8 mb-6">
        <AddButton
          text="Add your Banking Information"
          buttonText="Add Banking Information"
          onClick={() => modalHandle(null)}
        />

        <div className="grid grid-cols-2 gap-4">
          {banksDraft.length <= 0 && banks?.map((item) => (
            <EditCard>
               <div className="statusSection">
                {item.bankID.status === "Verified" && (
                  <Verified />
                )}
                {item.bankID.status === "Declined" && (
                  <Declined />
                )}
                {item.bankID.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.bankID?.status === "Requested" || item?.bankID?.status === "raised" || item?.bankID?.status === "pending" )&& (
                  <Requested />
                )}
              </div>
              <div className="h-[15rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(item?.bankID)}
              </div>
              <div className="actionseditDelete  gap-4">
                {/* <Button
                  onClick={() => modalHandle(item?.bankID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button> */}
                <Button
                  onClick={() => modalHandleDelete(item?.bankID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
          {banksDraft?.map((item) => (
            <EditCard>
               <div className="statusSection">
                {item.status === "Verified" && (
                  <Verified />
                )}
                {item.status === "Declined" && (
                  <Declined />
                )}
                {item.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.status === "Requested" || item?.status === "raised"|| item?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="h-[15rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(item)}
              </div>
              <div className="actionseditDelete gap-4">

                {/* <Button
                  onClick={() => modalHandle(item)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button> */}
                <Button
                  onClick={() => modalHandleDelete(item)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>

            </EditCard>
          ))}
        </div>
      </div>

      <BackNextButton
        onPrev={() => onPrev(6, "Business Relation", "Details")}
        onNext={() => onNext(1, "Insurance", "Financial")}
        onSkip={() => onSkip(1, "Insurance", "Financial")}
      />
    </div>
  );
};
